import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';

import VideoPreview from '@/components/media/VideoPreview.js';

const JianyingTemplatePreviewField = ({
  disabled = false,
  onFileChange,
  onRemove,
  pendingFile,
  previewUrl,
  templateName,
}) => {
  const inputRef = useRef(null);
  const [localPreviewUrl, setLocalPreviewUrl] = useState('');

  useEffect(() => {
    if (!pendingFile) {
      setLocalPreviewUrl('');
      return undefined;
    }
    const objectUrl = URL.createObjectURL(pendingFile);
    setLocalPreviewUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [pendingFile]);

  const displayedUrl = localPreviewUrl || previewUrl;

  const selectFile = (file) => {
    if (file) onFileChange?.(file);
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <div className="jianying-template-preview-field">
      <div className="jianying-template-preview-field__media">
        {displayedUrl ? (
          <VideoPreview
            ariaLabel={`播放 ${templateName || '模板'} 预览视频`}
            className="jianying-template-preview-field__preview"
            overlay={(
              <span className="jianying-template-preview-field__play" aria-hidden="true">
                <i className="bi bi-play-fill" />
              </span>
            )}
            src={displayedUrl}
            title={templateName || '模板预览'}
          />
        ) : (
          <div className="jianying-template-preview-field__empty">
            <i className="bi bi-camera-video" />
            <span>未选择模板视频</span>
          </div>
        )}
      </div>
      <div className="jianying-template-preview-field__actions">
        <input
          ref={inputRef}
          type="file"
          accept="video/*"
          hidden
          disabled={disabled}
          onChange={(event) => selectFile(event.target.files?.[0])}
        />
        <Button
          type="button"
          size="sm"
          variant="outline-primary"
          disabled={disabled}
          onClick={() => inputRef.current?.click()}
        >
          <i className="bi bi-folder2-open" />
          <span>{displayedUrl ? '重新选择' : '选择视频'}</span>
        </Button>
        {displayedUrl ? (
          <Button
            type="button"
            size="sm"
            variant="outline-danger"
            aria-label="移除模板视频"
            title="移除模板视频"
            disabled={disabled}
            onClick={onRemove}
          >
            <i className="bi bi-trash3" />
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default JianyingTemplatePreviewField;
